<script setup>
import {ref, onBeforeMount, reactive, nextTick} from "vue";
import YTCard from "@/components/YTCard/YTCard.vue";
import router from "@/router/index.js";
import BoxUpload from "@/components/YTBoxUpload/index.vue";
import validatorRules from "@/utils/validator-rules.js";
import {addClub, editClub, getClub} from "@/api/club/club.js";
import {getRoute} from "@/hooks/getRoute.js";
import YTAddress from "@/components/YTAddress/index.vue";
import moment from "moment";
/*获取路由信息，带参则为修改*/
const {route} = getRoute()

onBeforeMount(async () => {
  console.log("route.query", route.query.storeId)
  isEdit.value = Boolean(route.query.storeId)
  if (isEdit.value) {
    await getDetail(route.query.storeId)
  }
})


// 带参则为修改
const isEdit = ref(false)
// 表单加载状态
const loading = ref(false);
// 表单锚点
const ruleFormRef = ref()
// 表单
const ruleForm = reactive({
  storeLogo: null,
  storeId: null,
  name: null,
  nameEn: "Coming Soon ...",
  summary: null,
  summaryEn: "Coming Soon ...",
  description: null,
  descriptionEn: "Coming Soon ...",
  phone:null,
  storeAddress: {
    provinceCode: null,
    cityCode: null,
    districtCode: null,
    street: null,
    streetEn: null
  },
  showAddressCode: null,
  street: null,
  streetEn: "Coming Soon ...",
  personnelInfo: [
    {
      avatar: null,
      name: null,
      nameEn: "Coming Soon ...",
      summaryInfo: [
        {
          summary: null,
          summaryEn: "Coming Soon ..."
        }
      ]
    }
  ]
})
// 手机号校验规则
const checkPhone = (rule, value, callback) => {
  if (value) {
    if (!validatorRules.isPhone(value)) {
      callback(new Error('手机号码格式不正确'))
    }
  }
  callback()
}
// 俱乐部logo校验规则
const checkImagesList = (rule, value, callback) => {
  const listLength = boxUploadRef.value.fileList.length
  if (listLength < 1) {
    return callback(new Error('请上传一张俱乐部Logo'))
  }
  callback()
}
// 俱乐部名称校验规则
const checkClubName = (rule, value, callback) => {
  if (!ruleForm.name) {
    return callback(new Error("俱乐部名称（中文）不能为空！"))
  }
  if (!ruleForm.nameEn) {
    return callback(new Error("俱乐部名称（English）不能为空！"))
  }
  return callback()
}
// 俱乐部人员头像校验规则
const checkPersonnelAvatar = (rule, value, callback) => {
  for (let i = 0; i <  ruleForm.personnelInfo.length; i++) {
    console.log("[i]", i)
    console.log("ruleForm.personnelInfo[i]", ruleForm.personnelInfo[i])
    if (!ruleForm.personnelInfo[i].avatar && !boxUploadAvatarRef.value[i].isChange) {
      return callback(new Error(`人员信息中第${i + 1}项人员头像未上传`))
    }
  }
  return callback()
}
// 俱乐部人员名称校验规则
const checkPersonnelName = (rule, value, callback) => {
  for (let i = 0; i <  ruleForm.personnelInfo.length; i++) {

    if (!ruleForm.personnelInfo[i].name) {
      console.log("ruleForm.personnelInfo[i].name", ruleForm.personnelInfo[i].name)
      return callback(new Error(`人员信息中第${i + 1}项人员名称（中文）未填写`))
    }
    if (!ruleForm.personnelInfo[i].nameEn) {
      return callback(new Error(`人员信息中第${i + 1}项人员名称（English）未填写`))
    }
  }
  return callback()
}
// 俱乐部人员简介校验规则
const checkSummaryInfo = (rule, value, callback) => {
  for (let i = 0; i <  ruleForm.personnelInfo.length; i++) {
    for (let j = 0; j < ruleForm.personnelInfo[i].summaryInfo.length; j++) {
      if (!ruleForm.personnelInfo[i].summaryInfo[j].summary) {
        return callback(new Error(`人员信息中第${i + 1}项的第${j + 1}人员简介（中文）未填写`))
      }
      if (!ruleForm.personnelInfo[i].summaryInfo[j].summaryEn) {
        return callback(new Error(`人员信息中第${i + 1}项的第${j + 1}人员简介（English）未填写`))
      }
    }
  }
  return callback()
}
// 俱乐部地址校验规则
const checkAddress = (rule, value, callback) => {
  if (!ruleForm.showAddressCode) return callback(new Error("请选择俱乐部地址"))
  return callback()
}
// 俱乐部简介校验规则
const checkSummary = (rule, value, callback) => {
  if (!ruleForm.summary) {
    return callback(new Error("俱乐部简介（中文）不能为空！"))
  }
  if (!ruleForm.summaryEn) {
    return callback(new Error("俱乐部简介（English）不能为空！"))
  }
  return callback()
}
// 俱乐部描述校验规则
const checkDescription = (rule, value, callback) => {
  if (!ruleForm.description) {
    return callback(new Error("俱乐部描述（中文）不能为空！"))
  }
  if (!ruleForm.descriptionEn) {
    return callback(new Error("俱乐部描述（English）不能为空！"))
  }
  return callback()
}
// 表单校验规则
const rules = reactive({
  storeLogo: [
    {required: true, validator: checkImagesList, trigger: "blur"},
  ],
  name: [
    {required: true, validator: checkClubName, trigger: "blur"},
  ],
  phone: [
    {required: true, validator: checkPhone, trigger: "blur"}
  ],
  personnelInfo: {
    avatar: [
      { required: true, validator: checkPersonnelAvatar }
    ],
    name: [
      { required: true, validator: checkPersonnelName, trigger: "change" },
    ],
    summaryInfo: [
      { required: true, validator: checkSummaryInfo, trigger: "change" },
    ]
  },
  summary: [
    { required: true, validator: checkSummary, trigger: 'blur' }
  ],
  description: [
    { required: true, validator: checkDescription, trigger: 'blur' }
  ],
  storeAddress: [
    { required: true, validator: checkAddress, trigger: 'blur' }
  ]
})

/*上传图片组件相关*/
// 图片上传组件锚点
const boxUploadRef = ref()
// 处理图片列表删除
const handleImageRemove = (url) => {
  ruleForm.storeLogo = url[0] ? url[0] : null
  ruleFormRef.value.validateField("storeLogo")
}
// 处理图片上传成功
const handlePicSuccess = (url) => {
  ruleForm.storeLogo = null
  ruleForm.storeLogo = url[0]
  loading.value = false
}
// 处理图片反显
const handleReviewPic = (reviewList) => {
  boxUploadRef.value.handleReview(reviewList)
}
// 处理人员信息头像删除
const handlePersonnelAvatarRemove = (url, index) => {
  ruleForm.personnelInfo[index].avatar = url[0]
  ruleFormRef.value.validateField("personnelInfo.avatar")
}
// 处理人员信息头像上传成功
const handlePersonnelAvatarSuccess = (url, index) => {
  console.log(`第${index + 1}个人员头像上传成功`)

  // 更新表单数据
  if (!ruleForm.personnelInfo[index]) {
    ruleForm.personnelInfo[index] = {
      avatar: null,
      name: null,
      nameEn: "Coming Soon ...",
      summaryInfo: [
        {
          summary: null,
          summaryEn: "Coming Soon ..."
        }
      ]
    }
  }
  ruleForm.personnelInfo[index].avatar = url[0]
  loading.value = false
}
// 处理人员头像反显
const handleReviewPersonnelInfoUploadPic = (reviewList) => {
  boxUploadAvatarRef.value.forEach((item, index) => {
    console.log("人员头像图片", [reviewList[index].avatar])
    if (reviewList[index].avatar) {
      item.handleReview([reviewList[index].avatar])
    }
  })
}

// 创建/修改俱乐部
const createClub = async () => {
  try {
    console.log("isEdit.value", isEdit.value)
    loading.value = true
    if (isEdit.value) {
      await editClub(ruleForm.storeId, ruleForm)
    } else {
      await addClub(ruleForm)
    }
    ElMessage.success(isEdit.value ? "修改俱乐部成功" : "新建俱乐部成功")
    router.push("/listClub")
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}

// 获取详情信息
const getDetail = async (info) => {
  open.value = true
  try {
    loading.value = true
    const res = await getClub(info)
    isEdit.value = true
    loading.value = false
    console.log(res)
    Object.assign(ruleForm, res)
    // 特殊处理地址反显
    let temp = []
    if (ruleForm.storeAddress) {
      temp.push(ruleForm.storeAddress.provinceCode)
      temp.push(ruleForm.storeAddress.cityCode)
      temp.push(ruleForm.storeAddress.districtCode)
      ruleForm.showAddressCode = temp.join("/")
    }
    handleReviewPic([res.storeLogo])
    nextTick(() => {
      // 反显人员头像
      handleReviewPersonnelInfoUploadPic(ruleForm.personnelInfo)
    })
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}

// 取消新增
const cancelAdd = () => {
  router.back()
}

// 保存校验表单
const submit = async () => {
  try {
    if (ruleForm.personnelInfo.length <= 0) {
      return ElMessage.error("至少添加一条人员信息")
    }
    console.log("run in submit")
    ruleFormRef.value.validate(async (valid) => {
      if (valid) {
        loading.value = true;
        createClub()
      } else {
        ElMessage({
          message: "请根据提示修改表单信息",
          type: "error",
        })
        console.log("run in else")
      }
      loading.value = false;
    })
  } catch (e) {
    console.log(e)
    loading.value = false;
  }
}

/*中英文切换输入框相关Tab*/
// 俱乐部名称tab
const clubNameTab = ref("zh")
// 俱乐部简介tab
const clubSummaryTab = ref("zh")
// 俱乐部描述tab
const clubDescTab = ref("zh")
// 俱乐部地址tab
const clubStreetTab = ref("zh")
// 人员名称tab
const memberAvatarTab = ref(["zh", "zh", "zh"])
// 人员简介tab
const memberDescTab = ref([["zh", "zh", "zh"], ["zh", "zh", "zh"], ["zh", "zh", "zh"]])

/*选择地址相关*/
// 处理选择所属区域
const handleSelectAddress = (data) => {
  console.log("data:", data)
  const res = data.value.split("/")
  ruleForm.showAddressCode = data.value.split("/")
  ruleForm.storeAddress.provinceCode = res[0]
  ruleForm.storeAddress.cityCode = res[1]
  ruleForm.storeAddress.districtCode = res.length > 2 ? res[2] : null
  ruleFormRef.value.validateField("storeAddress")
}

/*增加人员相关*/
// 增加人员
const handleAddMember = () => {
  if (ruleForm.personnelInfo.length >= 3) {
    return ElMessage.error("最多添加三人！")
  }
  ruleForm.personnelInfo.push({
    avatar: null,
    name: null,
    nameEn: "Coming Soon ...",
    summaryInfo: [
      {
        summary: null,
        summaryEn: "Coming Soon ..."
      }
    ]
  })
}
// 增加人员简介
const handleAddDesc = (item) => {
  if (item.summaryInfo.length >= 3) {
    return ElMessage.error("人员简介最多三条")
  }
  item.summaryInfo.push({
    summary: null,
    summaryEn: "Coming Soon ..."
  })
}
// 人员头像锚点
const boxUploadAvatarRef = ref([])
// 删除人员简介
const handleRemoveSummary = (index, sonIndex) => {
  ruleForm.personnelInfo[index].summaryInfo.splice(sonIndex, 1)
}
// 删除人员信息
const handleRemovePersonnelInfo = (index) => {
  ruleForm.personnelInfo.splice(index, 1)
  nextTick(() => {
    // 反显人员头像
    handleReviewPersonnelInfoUploadPic(ruleForm.personnelInfo)
  })
}
</script>

<template>
  <div class="container_form">
    <el-form
        ref="ruleFormRef"
        style="max-width: 100%"
        :model="ruleForm"
        :rules="rules"
        label-width="auto"
        class="demo-ruleForm"
        size="large"
        v-loading="loading"
    >
      <YTCard :title="'基本信息'" :is-show-divider="true">
        <template #container>
          <el-form-item label="俱乐部Logo：" prop="storeLogo">
            <BoxUpload ref="boxUploadRef" :ali-oss-path="'STORE_LOGO'" :width="80" :height="80" :limit="1" :file-size="1" @progress="loading = true"  @remove="handleImageRemove" @success="handlePicSuccess"></BoxUpload>
          </el-form-item>
          <el-form-item label="俱乐部名称：" prop="name">
            <el-tabs
                v-model="clubNameTab"
                type="card"
                class="demo-tabs"
            >
              <el-tab-pane label="中文" name="zh">
                <el-input style="width: 350px" maxlength="20" show-word-limit v-model="ruleForm.name" placeholder="请输入俱乐部名称"></el-input>
              </el-tab-pane>
              <el-tab-pane label="English" name="en">
                <el-input style="width: 350px" maxlength="60" show-word-limit v-model="ruleForm.nameEn" placeholder="Please enter the name of the club"></el-input>
              </el-tab-pane>
            </el-tabs>
          </el-form-item>
          <el-form-item label="简介：" prop="summary">
            <el-tabs
                v-model="clubSummaryTab"
                type="card"
                class="demo-tabs"
            >
              <el-tab-pane label="中文" name="zh">
                <el-input style="width: 350px" maxlength="100" show-word-limit v-model="ruleForm.summary" placeholder="请输入一句话介绍"></el-input>
              </el-tab-pane>
              <el-tab-pane label="English" name="en">
                <el-input style="width: 350px" maxlength="300" show-word-limit v-model="ruleForm.summaryEn" placeholder="Please enter a one-sentence introduction"></el-input>
              </el-tab-pane>
            </el-tabs>
          </el-form-item>
          <el-form-item label="描述：" prop="description">
            <el-tabs
                v-model="clubDescTab"
                type="card"
                class="demo-tabs"
            >
              <el-tab-pane label="中文" name="zh">
                <el-input style="width: 350px" type="textarea" maxlength="200" resize="none" :rows="5" show-word-limit v-model="ruleForm.description" placeholder="请输入俱乐部描述"></el-input>
              </el-tab-pane>
              <el-tab-pane label="English" name="en">
                <el-input style="width: 350px" type="textarea" maxlength="600" resize="none" :rows="5" show-word-limit v-model="ruleForm.descriptionEn" placeholder="Please enter the club description"></el-input>
              </el-tab-pane>
            </el-tabs>
          </el-form-item>
          <el-form-item label="联系电话：" prop="phone">
            <el-input style="width: 350px" maxlength="11" show-word-limit v-model="ruleForm.phone" placeholder="请输入俱乐部联系电话"></el-input>
          </el-form-item>
          <el-form-item label="地址：" prop="storeAddress">
            <div>
              <div class="mg_b_2" style="width: 350px;">
                <YTAddress style="min-width: 498px;" :addressCode="ruleForm.showAddressCode" :is-return-str="true" @select="handleSelectAddress"></YTAddress>
              </div>
              <el-tabs
                  v-model="clubStreetTab"
                  type="card"
                  class="demo-tabs"
              >
                <el-tab-pane label="中文" name="zh">
                  <el-input style="width: 500px" show-word-limit v-model="ruleForm.storeAddress.addressDetail" placeholder="详细地址，例如街道门牌号"></el-input>
                </el-tab-pane>
                <el-tab-pane label="English" name="en">
                  <el-input style="width: 500px" show-word-limit v-model="ruleForm.storeAddress.addressDetailEn" placeholder="Detailed addresses, such as street house numbers"></el-input>
                </el-tab-pane>
              </el-tabs>
            </div>
          </el-form-item>
        </template>
      </YTCard>
      <YTCard :title="'人员信息'" :is-show-divider="false">
        <template #container>
          <div v-for="(item, index) in ruleForm.personnelInfo" :key="`personnelInfo${index}`">
            <el-form-item label="人员头像：" prop="personnelInfo.avatar">
              <div class="flex_align_t">
                <BoxUpload :ali-oss-path="'PERSONNEL_INFO_AVATAR_PATH'" :ref="el => { if (el) boxUploadAvatarRef[index] = el }" :width="80" :height="80" :limit="1" :file-size="1" @progress="loading = true" @success="(url) => handlePersonnelAvatarSuccess(url, index)" @remove="(url) => handlePersonnelAvatarRemove(url, index)"></BoxUpload>
                <div class="mg_l_2">
                  <el-tooltip
                      class="box-item"
                      effect="dark"
                      content="删除该人员信息"
                      placement="right">
                    <v-icon class="cursor-pointer" color="error" icon="mdi-close" @click="handleRemovePersonnelInfo(index)"></v-icon>
                  </el-tooltip>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="人员名称：" prop="personnelInfo.name">
              <el-tabs
                  v-model="memberAvatarTab[index]"
                  type="card"
                  class="demo-tabs"
              >
                <el-tab-pane label="中文" name="zh">
                  <el-input style="width: 500px" show-word-limit v-model="item.name" placeholder="人员名称"></el-input>
                </el-tab-pane>
                <el-tab-pane label="English" name="en">
                  <el-input style="width: 500px" show-word-limit v-model="item.nameEn" placeholder="Detailed addresses, such as street house numbers"></el-input>
                </el-tab-pane>
              </el-tabs>
            </el-form-item>
            <el-form-item label="人员简介：" prop="personnelInfo.summaryInfo">
              <div>
                <div class="flex_align_b">
                  <div>
                    <el-tabs
                        v-model="memberDescTab[index][sonIndex]"
                        type="card"
                        class="demo-tabs mg_r_1 mg_b_2"
                        v-for="(sonItem, sonIndex) in item.summaryInfo"
                        :key="`summaryInfo${index}${sonIndex}`"
                    >
                      <el-tab-pane label="中文" name="zh">
                        <div class="flex_left">
                          <el-input style="width: 500px" show-word-limit maxlength="40" v-model="sonItem.summary" placeholder="一般填写在俱乐部的角色"></el-input>
                          <div class="mg_l_1">
                            <el-tooltip
                                class="box-item"
                                effect="dark"
                                content="删除人员简介"
                                placement="right">
                              <v-icon v-if="item.summaryInfo.length > 1" class="cursor-pointer" color="error" icon="mdi-close" @click="handleRemoveSummary(index, sonIndex)"></v-icon>
                            </el-tooltip>
                          </div>
                        </div>
                      </el-tab-pane>
                      <el-tab-pane label="English" name="en">
                        <div class="flex_left">
                          <el-input style="width: 500px" show-word-limit maxlength="40" v-model="sonItem.summaryEn" placeholder="Detailed addresses, such as street house numbers"></el-input>
                          <div class="mg_l_1">
                            <el-tooltip
                                class="box-item"
                                effect="dark"
                                content="删除"
                                placement="right">
                              <v-icon v-if="item.summaryInfo.length > 1" class="cursor-pointer" color="error" icon="mdi-close" @click="handleRemoveSummary(index, sonIndex)"></v-icon>
                            </el-tooltip>
                          </div>
                        </div>
                      </el-tab-pane>
                    </el-tabs>
                  </div>
                </div>
                <div>
                  <v-icon class="cursor-pointer mg_r_2" icon="mdi-plus-circle-outline" color="success" size="32" @click="handleAddDesc(item)"></v-icon>
                  <span class="tips_default">最多三条简介，每个简介最多10字</span>
                </div>
              </div>
            </el-form-item>
            <el-divider></el-divider>
          </div>
          <div>
            <v-btn class="mg_r_2" @click="handleAddMember">增加人员</v-btn>
            <span class="tips_default">最多三人</span>
          </div>
        </template>
      </YTCard>
    </el-form>
    <v-row class="mg_t_2">
      <v-col cols="4">
        <v-row>
          <v-col cols="6">
            <v-btn @click="cancelAdd">取消</v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn color="primary" @click="submit">保存</v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<style lang="scss" scoped>

</style>
